import { Store } from '@ngrx/store';

import { SidebarCustomComponents } from '../../domain/constants/sidebar-custom-components';
import { SidebarView, SidebarCustomCommandProps } from '../../domain/models/sidebar.models';
import { SidebarCommandsFacade } from '../commands/sidebar.commands.facade';

export interface SidebarCommandsInterface {
    openSidebar: (view: SidebarView) => void;
    closeSidebar: (isNavigation?: boolean) => void;
    openSidebarCustom: (props: SidebarCustomCommandProps) => void;
}

export function SidebarPublicPort(store: Store): SidebarCommandsInterface {
    const command = new SidebarCommandsFacade(store);
    return {
        openSidebar: command.openSidebar.bind(command),
        closeSidebar: command.closeSidebar.bind(command),
        openSidebarCustom: command.openSidebarCustom.bind(command),
    };
}

export const SidebarPublicModels = {
    view: SidebarView,
    sidebarCustomComponents: SidebarCustomComponents,
};

export type PublicSidebarCustomCommandProps = SidebarCustomCommandProps;
